import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import PlayerRankingWidget from '../../components/stats/PlayerRankingWidget';
import { getRankingCompetitionMeta } from '../../../api';
import { useMemo } from 'react';
//import useViewToken from '../../components/live/hooks/useViewToken';

//   const { token, fetchToken } = useViewToken();

//   useEffect(() => {
//     if (!token) {
//       fetchToken(
//         process.env.REACT_APP_VIEW_CLIENT_ID,
//         process.env.REACT_APP_VIEW_CLIENT_SECRET
//       );
//     }
//   }, [token, fetchToken]);

//   if (!token) return null;



export default function PlayerRankingPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const provider = searchParams.get('provider') || '';
  const seasonParam = searchParams.get('season') || '';

  const competitionIdsParam = searchParams.get('competitionIds') || '';

  const competitionIds = useMemo(
    () =>
      competitionIdsParam
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean),
    [competitionIdsParam]
  );

  const firstCompetitionId = competitionIds[0];

  const [discipline, setDiscipline] = useState(null);
  const [season, setSeason] = useState(null);
  const [title, setTitle] = useState('Statistiques joueurs');

  useEffect(() => {
    let ignore = false;

    const loadMeta = async () => {
      if (!firstCompetitionId) {
        if (!ignore) {
          setDiscipline(null);
          setSeason(null);
          setTitle('Statistiques joueurs');
        }
        return;
      }

      try {
        const { data } = await getRankingCompetitionMeta(firstCompetitionId);

        if (!ignore) {
          setDiscipline(data?.discipline || null);
          setSeason(data?.season || null);
          setTitle(
            competitionIds.length > 1
              ? 'Statistiques joueurs'
              : data?.name || 'Statistiques joueurs'
          );
        }
      } catch (error) {
        if (!ignore) {
          setDiscipline(null);
          setSeason(null);
          setTitle('Statistiques joueurs');
        }
      }
    };

    loadMeta();

    return () => {
      ignore = true;
    };
  }, [firstCompetitionId, competitionIds.length]);

  if (!discipline || competitionIds.length === 0) return null;

  return (
    <PlayerRankingWidget
      provider={provider}
      discipline={discipline}
      season={seasonParam || null}
      competitionIds={competitionIds}
      title={title}
      onNavigate={(url) => navigate(url)}
    />
  );
}